import WorkshopSessionsModal from './WorkshopSessionsModal';

export default WorkshopSessionsModal;
